var exports = {
  "Nr": "card__YP6j-k",
  "ir": "reference__m9089L",
  "n5": "referenceText__fHrVqn",
  "$D": "titleHeading__GLZH1i",
  "DD": "title__Ro3HnD",
  "WD": "labels__IYXVhe",
  "y": "labelTooltip__LpCXfP",
  "kJ": "tooltipHidden__jIuCtR",
  "Ru": "labelLink__tmNr2c",
  "Jf": "labelOverflowButton__eqYo01",
  "bi": "labelOverflowList__uvtPCs",
  "mI": "meta__yFP9_X",
  "FK": "milestone__sbnY_f",
  "Hy": "assignees__iBVU9v",
  "vL": "assigneeItem__Smxt-P",
};

module.exports = exports;
